import { render } from "./Radio-Checkbox.vue?vue&type=template&id=ca442ee2&scoped=true"
import script from "./Radio-Checkbox.vue?vue&type=script&lang=js"
export * from "./Radio-Checkbox.vue?vue&type=script&lang=js"

import "./Radio-Checkbox.vue?vue&type=style&index=0&id=ca442ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca442ee2"]])

export default __exports__